import { IconType } from "react-icons/lib";
import { MaterialIcons } from "./styles";

interface IconProps {
    color?: string;
    backgroundColor?: string;
    icon: IconType;
}

export function Icon({ color, backgroundColor, icon: Icon }: IconProps) {
  return <MaterialIcons color={color} backgroundColor={backgroundColor}><Icon /></MaterialIcons>;
}
